module.exports = __webpack_public_path__ + "static/media/lite_plan.258b857e.png";